// Game-setup helpers shared by server (authoritative validation) and client
// (placement affordances). Pure and derived — no synced state.
import { deriveSlots } from "../tiles/slots.js";
/**
 * Node ids on the **outermost ("forest") tiles** — the legal region for a
 * player's home base. Derived from the board's geometric slots (`deriveSlots`),
 * so the server and client agree on "the outer tiles" without syncing anything,
 * exactly like zone derivation. A node's *availability* (unoccupied) is checked
 * separately against live `NodeState`.
 */
export function forestNodeIds(board) {
    const ids = [];
    for (const slot of deriveSlots(board)) {
        if (slot.zone === "forest")
            ids.push(...slot.nodeIds);
    }
    return ids;
}
//# sourceMappingURL=setup.js.map